class Burger {
    static init() {
        this.html = document.querySelector("html");
        this.header = document.querySelector(".header");
        this.bloc = document.querySelector(".header__burger");
        if (this.header && this.bloc) {
            for (let i = 0; i < 3; i++) {
                let span = document.createElement("span");
                this.bloc.appendChild(span);
            }

            this.bloc.addEventListener("click", () => {
                this.html.classList.toggle("html--noscroll");
                this.header.classList.toggle("header--burgerOpen");
            })
        }
    }
}

export default Burger;


// WEBPACK FOOTER //
// ./src/scripts/components/burger.js